import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BookmarkIcon } from '@heroicons/react/outline';
import { Card } from '../components';
import { onSavedChange, savedJobs } from '../utils/savedJobs';

// Saved jobs (feature "savedJobs"): only what this browser saved, read from localStorage.
export default function Saved() {
  const [jobs, setJobs] = useState(savedJobs);
  useEffect(() => onSavedChange(() => setJobs(savedJobs())), []);
  return (
    <section className="mx-auto max-w-4xl px-4 py-12">
      <h1 className="font-display text-3xl font-bold text-gray-900">Saved jobs</h1>
      <p className="mt-2 text-sm text-gray-600">Saved on this device only. Nothing is sent to us or to employers.</p>
      <div className="mt-8">
        {jobs.length ? (
          jobs.map((j) => (
            <Card
              key={j.id}
              btnId={j.id}
              title={j.title}
              companyName={j.companyName}
              categories={j.categories}
              city={j.city}
              salary={j.salary}
              postedOn={j.postedOn}
              externalUrl={j.externalUrl || undefined}
              source={j.source || undefined}
              postExpiry={j.postExpiry}
            />
          ))
        ) : (
          <div className="rounded-2xl border border-dashed border-gray-300 bg-white p-10 text-center">
            <BookmarkIcon className="mx-auto h-10 w-10 text-gray-400" aria-hidden="true" />
            <p className="mt-3 font-semibold text-gray-900">No saved jobs yet</p>
            <p className="mt-1 text-sm text-gray-600">Tap the bookmark on any job to keep it here for later.</p>
            <Link to="/jobs" className="mt-5 inline-flex rounded-full bg-primary px-5 py-2 font-semibold text-white hover:opacity-90">
              Browse jobs
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}
